import React from 'react';
import styles from './LeaderboardHeader.module.scss';

interface LeaderboardHeaderProps {
  isLoading: boolean;
}

const LeaderboardHeader: React.FC<LeaderboardHeaderProps> = ({ isLoading }) => {
  return (
    <div
      className={`${styles.leaderboardHeader} ${isLoading ? styles.leaderboardHeader_loading : ''}`}
    >
      <div className={styles.leaderboardHeader__content}>
        <div className={styles.leaderboardHeader__title}>
          Будь в числе лучших
        </div>
        <div className={styles.subtitle}>
          и занимай место среди топ-игроков.
        </div>
      </div>
    </div>
  );
};

export default LeaderboardHeader;
